import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/styles";
import IosShareIcon from "@mui/icons-material/IosShare";
import { colors, gaps } from "theme/defaultStyle";

const TextStyles = styled("span")({
  fontWeight: 600,
  display: "flex",
  alignItems: "center",
  gap: gaps.small1,
});

const RotatedIcon = styled(IosShareIcon)({
  transform: "rotate(90deg)",
});

interface ExportButtonProps {
  onClick?: () => void;
  disabled?: boolean;
}

const ExportButton = ({ onClick, disabled }: ExportButtonProps) => (
  <Button
    style={{
      backgroundColor: colors.white,
      opacity: 1,
      textTransform: "none",
    }}
    onClick={onClick}
    disabled={disabled}
  >
    <TextStyles>
      Export
      <RotatedIcon />
    </TextStyles>
  </Button>
);

export default ExportButton;
